import { render, staticRenderFns } from "./Pharmacist.vue?vue&type=template&id=1fd24ff2"
import script from "./Pharmacist.vue?vue&type=script&lang=js"
export * from "./Pharmacist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports